import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import ParametersList from './pages/Parameters';
import StudyList from './pages/Study/StudyList';
import SupplierList from './pages/Supplier/SupplierList';
import EnergyFlagList from './pages/EnergyFlag/EnergyFlagList';
import SubClassList from './pages/SubClass/SubClassList';
import GD2List from './pages/GD2List/GD2List';
import ConnectionTypeList from './pages/ConnectionType/ConnectionTypeList';
import FlagHistoryList from './pages/FlagHistory/FlagHistoryList';
import FlagHistoryAdd from './pages/FlagHistory/FlagHistoryAdd';
import UserList from './pages/User/UserList';
import DistributionFeeList from './pages/DistributionFee/DistributionFeeList';
import DistributionFeeAdd from './pages/DistributionFee/DistributionFeeAdd';
import DistributionFeeEdit from './pages/DistributionFee/DistributionFeeEdit';
import StudyEdit from './pages/Study/StudyEdit';
import FlagHistoryEdit from './pages/FlagHistory/FlagHistoryEdit';
import FlagEconmomyList from './pages/FlagEconomy/FlagEconomyList';
import FlagEconmomyAdd from './pages/FlagEconomy/FlagEconomyAdd';
import FlagEconmomyEdit from './pages/FlagEconomy/FlagEconomyEdit';
import D4SignTemplates from './pages/D4SignTemplates';
import SalesChannelList from './pages/SalesChannel/SalesChannelList';

function App() {
  return (
    <BrowserRouter basename="/">
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/templates" element={<D4SignTemplates />} />
        <Route path="/study/list" element={<StudyList />} />
        <Route path="/study/edit/:id" element={<StudyEdit />} />
        <Route path="/supplier/list" element={<SupplierList />} />
        <Route path="/energy/list" element={<EnergyFlagList />} />
        <Route path="/sub_class/list" element={<SubClassList />} />
        <Route path="/gd2/list" element={<GD2List />} />
        <Route path="/connection_type/list" element={<ConnectionTypeList />} />
        <Route path="/flag_hist/list" element={<FlagHistoryList />} />
        <Route path="/flag_hist/add" element={<FlagHistoryAdd />} />
        <Route path="/flag_hist/edit/:id" element={<FlagHistoryEdit />} />
        <Route path="/user/list" element={<UserList />} />
        <Route path="/sales_channel/list" element={<SalesChannelList />} />
        <Route path="/distribution_fee/list" element={<DistributionFeeList />} />
        <Route path="/distribution_fee/add" element={<DistributionFeeAdd />} />
        <Route path="/distribution_fee/edit/:id" element={<DistributionFeeEdit />} />
        <Route path="/parameters" element={<ParametersList />} />
        <Route path="/flag_economy/list" element={<FlagEconmomyList />} />
        <Route path="/flag_economy/add" element={<FlagEconmomyAdd />} />
        <Route path="/flag_economy/edit/:id" element={<FlagEconmomyEdit />} />
        <Route path="/d4sign/templates" element={<D4SignTemplates />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
